export const localeNames = {
  'en': 'English',
  'en-US': 'English',
  'sv': 'Svenska',
  'sv-SE': 'Svenska',
};
